module.exports = __webpack_public_path__ + "img/place10.1b57c19e.jpg";